import { createContext, useContext } from 'react';
import type { PortalMembership } from '../api/portalSession';

export interface PropertyContextValue {
  /** `null` while memberships are still loading, or once loaded, when
   * there are none — never a stale/unvalidated id (fix round 1, item 1). */
  businessId: string | null;
  role: PortalMembership['role'] | null;
  memberships: PortalMembership[];
  selectBusiness: (id: string) => void;
}

// Context + hook live in their own module — see authContext.ts's comment
// for why (fix round 1, item 12: react-refresh/only-export-components).
export const PropertyContext = createContext<PropertyContextValue | undefined>(undefined);

export function useProperty(): PropertyContextValue {
  const ctx = useContext(PropertyContext);
  if (!ctx) throw new Error('useProperty must be used within a PropertyProvider');
  return ctx;
}
